import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiLock, FiUser } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import '../../styles/SignInPrompt.css';

interface SignInPromptProps {
  message: string;
  onClose: () => void;
  /** Use "float" for absolute-positioned popover (e.g. above chat input) */
  variant?: 'inline' | 'float';
}

const SignInPrompt: React.FC<SignInPromptProps> = ({ message, onClose, variant = 'inline' }) => {
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <motion.div
      ref={ref}
      className={`signin-prompt ${variant === 'float' ? 'signin-prompt--float' : ''}`}
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 4 }}
      transition={{ duration: 0.15 }}
    >
      <span className="signin-prompt__icon"><FiLock size={12} /></span>
      <span className="signin-prompt__message">{message}</span>
      <button
        className="signin-prompt__btn glass-btn-primary"
        onClick={() => { navigate(ROUTES.LOGIN); onClose(); }}
      >
        <FiUser size={11} />
        Sign In
      </button>
    </motion.div>
  );
};

export default SignInPrompt;
